(function () {
    const freeShippingThreshold = 40.00; // Free shipping threshold

    function updateFreeShippingMessage(cartTotal, targetMessageId, targetProgressId) {
        const messageElement = document.getElementById(targetMessageId);
        const progressBarElement = document.getElementById(targetProgressId);

        if (!messageElement || !progressBarElement) {
            console.error("Target elements not found");
            return;
        }

        // Ensure the progress bar is visible and not treated as empty
        progressBarElement.style.display = "block";
        progressBarElement.innerHTML = "&nbsp;"; // Prevent :empty rule

        if (cartTotal === 0) {
            messageElement.textContent = "Free shipping for orders over $40.00!";
            progressBarElement.style.width = "0%";
            progressBarElement.style.backgroundColor = "#e0e0e0";
        } else if (cartTotal >= freeShippingThreshold) {
            messageElement.textContent = "You've got free shipping!";
            progressBarElement.style.width = "100%";
            progressBarElement.style.backgroundColor = "#4CAF50";
        } else {
            const remaining = freeShippingThreshold - cartTotal;
            const progress = (cartTotal / freeShippingThreshold) * 100;

            messageElement.textContent = `Only $${remaining.toFixed(2)} away from free shipping!`;
            progressBarElement.style.width = `${progress}%`;
            progressBarElement.style.backgroundColor = "#4CAF50";
        }
    }

    async function fetchCartData(targetMessageId, targetProgressId) {
        try {
            const response = await fetch('/cart.js');
            const cart = await response.json();
            const cartTotal = cart.items_subtotal_price / 100; // Convert cents to dollars
            updateFreeShippingMessage(cartTotal, targetMessageId, targetProgressId);
        } catch (error) {
            console.error("Failed to fetch cart data:", error);
        }
    }

    function handleCartPageUpdates(targetMessageId, targetProgressId) {
        // Monitor DOM changes in the cart (for cart page quantity updates)
        const cartContainer = document.querySelector('.cart__items'); // Adjust selector for your theme
        if (cartContainer) {
            const observer = new MutationObserver(() => fetchCartData(targetMessageId, targetProgressId));
            observer.observe(cartContainer, { childList: true, subtree: true });
        }

        // Fallback: Listen for custom cart:updated events if available
        document.addEventListener('cart:updated', () => fetchCartData(targetMessageId, targetProgressId));
    }

    function handleProductPageUpdates(targetMessageId, targetProgressId) {
        // Traditional form submission listener (for non-AJAX themes)
        const addToCartForm = document.querySelector('form[action="/cart/add"]');
        if (addToCartForm) {
            addToCartForm.addEventListener('submit', () => {
                setTimeout(() => fetchCartData(targetMessageId, targetProgressId), 1000); // Delay for cart update
            });
        }

        // Intercept AJAX-based add-to-cart actions
        const originalFetch = window.fetch;
        window.fetch = async (...args) => {
            const [url] = args;

            // Call the original fetch
            const response = await originalFetch(...args);

            // Check if this is a cart update (add-to-cart API call)
            if (url.includes('/cart/add')) {
                setTimeout(() => fetchCartData(targetMessageId, targetProgressId), 500); // Small delay to ensure cart updates
            }

            return response;
        };

        // Intercept XMLHttpRequest (for older themes using XHR)
        const originalXHR = XMLHttpRequest.prototype.send;
        XMLHttpRequest.prototype.send = function () {
            this.addEventListener('load', function () {
                if (this.responseURL.includes('/cart/add')) {
                    setTimeout(() => fetchCartData(targetMessageId, targetProgressId), 500); // Small delay to ensure cart updates
                }
            });
            originalXHR.apply(this, arguments);
        };
    }

    function initFreeShippingMessage(targetMessageId, targetProgressId) {
        // Initial fetch
        fetchCartData(targetMessageId, targetProgressId);

        // Detect if on cart page
        if (window.location.pathname.includes('/cart')) {
            handleCartPageUpdates(targetMessageId, targetProgressId);
        } else {
            // Detect if on product page
            handleProductPageUpdates(targetMessageId, targetProgressId);
        }
    }

    window.initFreeShippingMessage = function (targetMessageId, targetProgressId) {
        initFreeShippingMessage(targetMessageId, targetProgressId);
    };
})();